import React from 'react';
//
import TextInput from 'components/input/text';
import {
  InputError,
  InputGroup,
  InputGroupHeader,
  Label,
  ShowMoreButton,
} from 'components/formula-entry/modals/_common';
import { shouldRenderSection } from 'components/formula-entry/modals/costs/costs';
import { EProductNestedField, IPrice } from 'store/field-options/types';
import DotIconStyled from 'components/formula-entry/modals/costs/DotIconStyled';
import { IErrorsInitialStatesProps } from './costs-utility';

interface ICostOtherBatnaProps {
  errors: IErrorsInitialStatesProps;
  expandedSections: { expanded: boolean; description: string }[];
  handleOtherBatnaOnChange: Function;
  handleSectionClick: Function;
  index: number;
  otherBatna: IPrice;
  pricePerUnitLabel: string;
  volumeUnit: string;
}

const valueForBatna = 2;

const CostsOtherBatna = ({
  expandedSections,
  index,
  otherBatna,
  errors,
  volumeUnit,
  pricePerUnitLabel,
  handleOtherBatnaOnChange,
  handleSectionClick,
}: ICostOtherBatnaProps) => {
  const showMoreButtonOtherBatna =
    Number.parseInt(otherBatna.costIncInventory?.toString() ?? '', 10) ||
    Number.parseInt(otherBatna.costTransitDays?.toString() ?? '', 10) ||
    Number.parseInt(otherBatna.costFixed?.toString() ?? '', 10);

  return (
    <div key={`other-batna-${index}`}>
      <InputGroupHeader>
        BATNA {index + valueForBatna} - {otherBatna.description}
      </InputGroupHeader>
      <InputGroup>
        <Label data-valid={!!errors.otherBatnas[index].costReimbursed} htmlFor={`batna-cost-reimbursed-${index}`}>
          REIMBURSED SUPPLY COST ({pricePerUnitLabel})
        </Label>
        <TextInput
          id={`batna-cost-reimbursed-${index}`}
          value={otherBatna.costReimbursed}
          onChange={e => handleOtherBatnaOnChange(index, EProductNestedField.COST_REIMBURSED, e.target.value)}
        />
        <InputError>{errors.otherBatnas[index].costReimbursed}</InputError>
      </InputGroup>
      <InputGroup>
        <Label data-valid={!!errors.otherBatnas[index].costFreight} htmlFor={`batna-cost-freight-${index}`}>
          VARIABLE SUPPLY COST ({pricePerUnitLabel})
        </Label>
        <TextInput
          id={`batna-cost-freight-${index}`}
          value={otherBatna.costFreight}
          onChange={e => handleOtherBatnaOnChange(index, EProductNestedField.COST_FREIGHT, e.target.value)}
        />
        <InputError>{errors.otherBatnas[index].costFreight}</InputError>
      </InputGroup>

      {shouldRenderSection(expandedSections, otherBatna.description) ? (
        <div className="hidden-area">
          <InputGroup>
            <Label data-valid={!!errors.otherBatnas[index].costFixed} htmlFor={`batna-cost-fixed-${index}`}>
              FIXED ANNUAL SUPPLY COST ($/YR)
            </Label>
            <TextInput
              id={`batna-cost-fixed-${index}`}
              value={otherBatna.costFixed}
              onChange={e => handleOtherBatnaOnChange(index, EProductNestedField.COST_FIXED, e.target.value)}
            />
            <InputError>{errors.otherBatnas[index].costFixed}</InputError>
          </InputGroup>

          <InputGroup>
            <Label
              data-valid={!!errors.otherBatnas[index].costIncInventory}
              htmlFor={`batna-cost-inc-inventory-${index}`}
            >
              ADDITIONAL INVENTORY ({volumeUnit.toUpperCase()})
            </Label>
            <TextInput
              id={`batna-cost-inc-inventory-${index}`}
              value={otherBatna.costIncInventory}
              onChange={e => handleOtherBatnaOnChange(index, EProductNestedField.COST_INVENTORY, e.target.value)}
            />
            <InputError>{errors.otherBatnas[index].costIncInventory}</InputError>
          </InputGroup>

          <InputGroup>
            <Label
              data-valid={!!errors.otherBatnas[index].costTransitDays}
              htmlFor={`batna-cost-transit-days-${index}`}
            >
              ADDITIONAL TRANSIT DAYS
            </Label>
            <TextInput
              id={`batna-cost-transit-days-${index}`}
              value={otherBatna.costTransitDays}
              onChange={e => handleOtherBatnaOnChange(index, EProductNestedField.COST_TRANSIT_DAYS, e.target.value)}
            />
            <InputError>{errors.otherBatnas[index].costTransitDays}</InputError>
          </InputGroup>
          <ShowMoreButton onClick={() => handleSectionClick(otherBatna.description)}>show less</ShowMoreButton>
        </div>
      ) : (
        <ShowMoreButton onClick={() => handleSectionClick(otherBatna.description)}>
          show more {showMoreButtonOtherBatna ? <DotIconStyled /> : null}
        </ShowMoreButton>
      )}
    </div>
  );
};

export default CostsOtherBatna;
